import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import Logo from '../assets/images/BlombosLogo.svg';
import { onLoggedin } from '../actions';
import { userLogin } from '../api/loginApi';
import { validateEmail } from '../utils/common';
import { toast } from 'sonner';

const Login = (props) => {
  const [isLoad, setIsLoad] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      setIsLoad(false);
    }, 500);
    document.body.classList.remove('theme-cyan');
    document.body.classList.remove('theme-purple');
    document.body.classList.remove('theme-blue');
    document.body.classList.remove('theme-green');
    document.body.classList.remove('theme-orange');
    document.body.classList.remove('theme-blush');
  }, []);

  const handleRememberMeChange = (event) => {
    setRememberMe(event.target.checked);
  };

  const handleEmailChange = (event) => {
    const email = event.target.value;
    setEmail(email);
    if (!validateEmail(email)) {
      setEmailError('Invalid email address');
      return;
    } else {
      setEmailError('');
    }
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleUserLogin = async (e) => {
    e.preventDefault();
    if (!validateEmail(email)) {
      setEmailError('Invalid email address');
      return;
    }
    setEmailError('');
    toast.promise(userLogin(email, password), {
      loading: 'Logging in...',
      success: (data) => {
        props.onLoggedin(true);
        navigate('/');
        return 'Logged in successfully!';
      },
      error: (err) => {
        console.log(err);
        if (err.data.error == 'ResetPasswordRequired') {
          navigate('/updatepassword', { state: { email: email } });
          return 'Reset password required';
        }
        return 'Invalid email or password';
      },
      duration: 800,
    });
  };

  return (
    <div className="theme-cyan">
      <div
        className="page-loader-wrapper"
        style={{ display: isLoad ? 'block' : 'none' }}
      >
        <div className="loader">
          <div className="m-t-30">
            <img src={Logo} width="48" height="48" alt="Blombos" />
          </div>
          <p>Please wait...</p>
        </div>
      </div>
      <div className="hide-border">
        <div className="vertical-align-wrap">
          <div className="vertical-align-middle auth-main">
            <div className="auth-box">
              <div className="top">
                <img
                  src={Logo}
                  alt="Lucid"
                  style={{ width: '300px', margin: '10px' }}
                />
              </div>
              <form onSubmit={handleUserLogin}>
                <div className="card">
                  <div className="header">
                    <p className="lead">Login to your account</p>
                  </div>
                  <div className="body">
                    <div className="form-auth-small" action="index.html">
                      <div className="form-group">
                        <label className="control-label sr-only">Email</label>
                        <input
                          className="form-control"
                          id="signin-email"
                          placeholder="Email"
                          type="email"
                          value={email}
                          onChange={handleEmailChange}
                        />
                        {emailError && (
                          <div
                            className="error-message"
                            style={{ color: 'red' }}
                          >
                            {emailError}
                          </div>
                        )}
                      </div>
                      <div className="form-group">
                        <label className="control-label sr-only">
                          Password
                        </label>
                        <input
                          className="form-control"
                          id="signin-password"
                          placeholder="Password"
                          type="password"
                          value={password}
                          onChange={handlePasswordChange}
                        />
                      </div>
                      <div className="form-group clearfix">
                        <label className="fancy-checkbox element-left">
                          <input
                            type="checkbox"
                            checked={rememberMe}
                            onChange={handleRememberMeChange}
                          />
                          <span>Remember me</span>
                        </label>
                      </div>
                      <button
                        className="btn btn-primary btn-lg btn-block"
                        type="submit"
                      >
                        Login
                      </button>
                      <div className="bottom">
                        <span className="helper-text m-b-10">
                          <i className="fa fa-lock"></i>{' '}
                          <a href={`${process.env.PUBLIC_URL}/forgotpassword`}>
                            Forgot password?
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Login.propTypes = {
  isLoggedIn: PropTypes.bool,
};

const mapStateToProps = ({ loginReducer }) => ({
  isLoggedIn: loginReducer.isLoggedIn,
});

export default connect(mapStateToProps, {
  onLoggedin,
})(Login);
